import CardWithShadow from "../../common/CardWithShadow";
import TextWithIcon from "../../common/TextWithIcon";
import "./Contact.css";
import { ContactInfo } from "./ContactInfo";

const Contact = (props) => {
  const { businessLineDetails, campaignDetails } = props;
  if (!businessLineDetails) return <></>;

  const { companyName, companyLocation, companyAddress } = businessLineDetails;

  let classes = "col-12 mt-5 pl-md-0 pr-md-0 contact";
  if (props.noMarginBottomLarge) {
    classes = classes + " mb-md-0";
  }
  if (props.noMarginBottomSmall) {
    classes = classes + " mb-0";
  } else {
    classes = classes + " mb-5";
  }
  return (
    <div className={classes}>
      <CardWithShadow>
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <h4 className="text-orange">{companyName}</h4>
            </div>
            <div className={"col-md-" + (props.firstRowSize || 8)}>
              <TextWithIcon label={companyLocation} bold={true} />
              <TextWithIcon icon="map-alt.svg" label={companyAddress} />
            </div>
            {props.inlineInfo ? (
              <div className={"col-md-" + (props.secondRowSize || 4)}>
                <div className="inline-info">
                  <ContactInfo
                    inlineInfo={props.inlineInfo}
                    campaignDetails={campaignDetails}
                    {...businessLineDetails}
                  />
                </div>
              </div>
            ) : (
              <div className={"col-md-" + (props.secondRowSize || 4)}>
                <ContactInfo
                  inlineInfo={props.inlineInfo}
                  campaignDetails={campaignDetails}
                  {...businessLineDetails}
                />
              </div>
            )}
          </div>
        </div>
      </CardWithShadow>
    </div>
  );
};

export default Contact;
